namespace GeniuzPOS.Lookups {
    export interface CusProductSalesBeforeReferFlagRow {
        CusProductSalesBeforeReferFlag?: string;
        LookupName?: string;
    }

    export namespace CusProductSalesBeforeReferFlagRow {
        export const idProperty = 'CusProductSalesBeforeReferFlag';
        export const nameProperty = 'LookupName';
        export const localTextPrefix = 'Lookups.CusProductSalesBeforeReferFlag';
        export const lookupKey = 'Lookups.CusProductSalesBeforeReferFlag';

        export function getLookup(): Q.Lookup<CusProductSalesBeforeReferFlagRow> {
            return Q.getLookup<CusProductSalesBeforeReferFlagRow>('Lookups.CusProductSalesBeforeReferFlag');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            CusProductSalesBeforeReferFlag = "CusProductSalesBeforeReferFlag",
            LookupName = "LookupName"
        }
    }
}
